import { PaginatedRequest } from '@/app/common/utils/pagination/types';

export enum FineStatusEnum {
  PAID = 'paid',
  UNPAID = 'unpaid',
}

export interface VehicleFine {
  id: number;
  chassis: string;
  description: string | null;
  amount: number;
  fine_date: string;
  status: FineStatusEnum;
  createdAt: string;
  updatedAt: string | null;
}

export interface VehicleFineCreateParams {
  chassis: string;
  amount: number;
  fine_date: string;
  status?: FineStatusEnum;
  description?: string;
}

export interface VehicleFineUpdateParams {
  amount?: number;
  fine_date?: string;
  status?: FineStatusEnum;
  description?: string;
}

export interface VehicleFineFindAllParams extends PaginatedRequest {
  chassis?: string;
  status?: FineStatusEnum;
  from?: string;
  to?: string;
}

export interface VehicleFineSummaryParams {
  chassis?: string;
  from?: string;
  to?: string;
}

export interface VehicleFineSummary {
  total_amount: number;
  paid_amount: number;
  unpaid_amount: number;
  total_count: number;
  paid_count: number;
  unpaid_count: number;
  from: string | null;
  to: string | null;
}
